import { useState } from "react";
import LinjeKursist from "./LinjeKursist";
import { FmulinjeKursist } from "../../../../../interfaces/schema";
import UsersIcon from "../../../../icons/UsersIcon";
import KursusDeltagereHandlingerDropdown from "../../../kursus/id/Deltagere/KursusDeltagereHandlingerDropdown";
import { useQuery } from "@apollo/client";
import { GET_LINJE_BY_ID_FMULINJEKURSIST_QUERY } from "../../../../../api/linje/queries";
import { dateToyyyyMMdd } from "../../../../../util/date";
import Spinner from "../../../../spinner/Spinner";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import { defaultLinjeKursistColumns } from "../../../../../config/linjeConfig";
import { tableToXLSX } from "../../../../../util/tableExportUtils";

const LinjeKursister = ({ id }: { id: string }) => {
  // state
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  // queries and state
  const { data, loading, refetch, error } = useQuery<{
    fmulinje: {
      fmulinjeKursist: FmulinjeKursist[];
    };
  }>(GET_LINJE_BY_ID_FMULINJEKURSIST_QUERY(), {
    variables: { id, dato: dateToyyyyMMdd(new Date()) },
  });

  // custom hooks
  const [linjeKursistColumns] = useActiveColumns(
    "linje-linjekursist-active-columns",
    defaultLinjeKursistColumns,
  );

  if (loading) {
    return <Spinner label="Henter kursusdeltagere ..." />;
  }

  if (error) {
    return <div>Der skete en fejl ved indhentning af kursusdeltagere ...</div>;
  }

  const fmulinjeKursister = data?.fmulinje.fmulinjeKursist || [];
  const selectedLinjeKursister = fmulinjeKursister.filter((kursist) =>
    selectedIds.some((id) => kursist.id === id),
  );
  const selectedEmailAblePersonIds = selectedLinjeKursister.flatMap((kp) => {
    if (kp.person.prioriteretEmail) {
      return [kp.personId];
    } else {
      return [];
    }
  });

  const allSelected = selectedIds.length === fmulinjeKursister.length;

  // handlers
  function downloadToExcelHandler() {
    const selectedFmuLinjeKursister = fmulinjeKursister.flatMap((kursist) => {
      return selectedIds.find((id) => kursist.id === id) ? [kursist] : [];
    });

    tableToXLSX(linjeKursistColumns, selectedFmuLinjeKursister, {
      fileName: "fmulinje-kursister",
    });
  }

  return (
    <>
      <div className="container h-100 overflow-hidden">
        <div className="c-card p-0 h-100 overflow-hidden d-flex flex-column">
          <div className="py-3 px-4 d-flex justify-content-between align-items-center">
            <h3 className="d-flex align-items-center gap-2">
              <span className="c-theme-icon bg-primary-light text-primary">
                <UsersIcon />
              </span>
              Deltagere
              <span className="text-muted fw-medium">
                {selectedIds.length > 0 ? selectedIds.length + " ud af " : ""}
                {fmulinjeKursister.length}
              </span>
            </h3>
            <KursusDeltagereHandlingerDropdown
              typeTitle="deltagere"
              allSelected={allSelected}
              selectedIds={selectedIds}
              totalCount={selectedIds.length}
              emailAbleIds={selectedEmailAblePersonIds}
              type="fmulinje"
              typeId={id}
              badgeSolid
              onDownloadToExcel={downloadToExcelHandler}
            />
          </div>
          <LinjeKursist
            id={id}
            handlinger={{
              allSelected,
              selectedIds,
              setSelectedIds,
            }}
            fmulinjeKursist={fmulinjeKursister}
            refetch={refetch}
          />
        </div>
      </div>
    </>
  );
};

export default LinjeKursister;
